import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const GetProductTypes=({token, venue, includeFavorites, isPackageOrder}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/producttypes/${venue}`, { includeFavorites, isPackageOrder})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetProductType=({token, venue, _id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.get(`/producttypes/${venue}/id/${_id}`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const AddProductType=({token,productType}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/producttypes/add`,productType)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteProductType=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/producttypes/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteProductType=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/producttypes/undelete/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const UpdateProductType=({token,productType}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/producttypes/update/${productType._id}`,productType)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ReOrderProductTypes=({token,list}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/producttypes/reorder/`,list)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ImportMenu=({token,alias, data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/producttypes/import/${alias}`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}
const DeleteMenu=({token,alias, data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/producttypes/deletemenu/${alias}`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


export {
    GetProductTypes,
    GetProductType,
    AddProductType,
    DeleteProductType,
    UnDeleteProductType,
    UpdateProductType,
    ReOrderProductTypes,
    ImportMenu,
    DeleteMenu
}

